
import { MapLocation } from '@/types/location';

// 3 Days Gym Locations
export const threeDaysGyms: MapLocation[] = [
  {
    id: 13001,
    name: "3 Days Gym - Riyadh (Al Yasmeen)",
    type: "Gym",
    devices: 1,
    coordinates: [24.824738468055504, 46.64033685092359],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 13002,
    name: "3 Days Gym - Riyadh (Qurtubah) Male",
    type: "Gym",
    devices: 2,
    coordinates: [24.811708623442147, 46.735051906747024],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 13003,
    name: "3 Days Gym - Riyadh (Qurtubah) Female",
    type: "Gym",
    devices: 2,
    coordinates: [24.811365631343094, 46.7352510490764],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 13004,
    name: "3 Days Gym - Riyadh (Qurtubah) Kids",
    type: "Gym",
    devices: 1,
    coordinates: [24.811245547029472, 46.735379222088284],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "12-45",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 13005,
    name: "3 Days Gym - Riyadh (Al Waha)",
    type: "Gym",
    devices: 1,
    coordinates: [24.74543798779503, 46.72387124110441],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 13006,
    name: "3 Days Gym - Riyadh (Al Rawda) Male",
    type: "Gym",
    devices: 2,
    coordinates: [24.75993248989577, 46.79139835511678],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  },
  {
    id: 13007,
    name: "3 Days Gym - Riyadh (Al Rawda) Female",
    type: "Gym",
    devices: 2,
    coordinates: [24.7583736736788, 46.79036838692663],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "18-50",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
